/**
 * Tracks whether a drop-ship item's ship records were edited on the receiving screen.
 *
 * Saving used to re-post every drop-ship item's records, edited or not. For users without
 * drop-ship permission that request failed and aborted the rest of the save, leaving already
 * saved receives on screen to be submitted again (503094-10S was received 6 times for 2 ordered).
 *
 * DropshipEntryTable stamps the baseline once an item's records finish loading; ReceivingView
 * only sends items that changed since then.
 */

const BASELINE = "__dropShipBaseline";

function records(item: any): any[] {
	return [
		...(item.sizes || []).flatMap((size: any) => size.dropShipRecords || []),
		...(item.specialSizes || []).flatMap((size: any) => size.dropShipRecords || []),
		...(item.dropShipRecords || []),
	];
}

/** The saved-relevant content of an item's ship records (UI-only toggles excluded). */
export function dropShipSignature(item: any): string {
	return JSON.stringify(
		records(item).map((record) => {
			// eslint-disable-next-line @typescript-eslint/no-unused-vars
			const { showDatePicker, ...saved } = record;
			return saved;
		})
	);
}

/** Records the item's ship records as loaded. Non-enumerable so it never reaches a payload. */
export function markDropShipBaseline(item: any): void {
	Object.defineProperty(item, BASELINE, {
		value: dropShipSignature(item),
		enumerable: false,
		writable: true,
		configurable: true,
	});
}

/** True when the user edited the item's ship records since they loaded. */
export function dropShipChanged(item: any): boolean {
	// No baseline means its records never finished loading, so there is nothing to send.
	if (item[BASELINE] === undefined) return false;
	return dropShipSignature(item) !== item[BASELINE];
}
